<template>
    <div>
        <el-table
                :data="tableData"
                height="80vh"
                border
                style="width: 90vw;margin-left: 5vw;Border-radius:5px">
            <el-table-column
                    prop="unitName"
                    label="项目名称">
            </el-table-column>
            <el-table-column
                    prop="orderNo"
                    label="支付单号">
            </el-table-column>
            <el-table-column
                    prop="startTime"
                    label="开始时间"
                    width="180">
                <template slot-scope="scope">
                    {{new Date(scope.row.startTime * 1000).toLocaleString()}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="endTime"
                    label="有效时间"
                    width="180">
                <template slot-scope="scope">
                    {{new Date(scope.row.endTime * 1000).toLocaleString()}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="channelNum"
                    label="通道数量"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="payTime"
                    label="缴费时间"
                    width="180">
                <template slot-scope="scope">
                    {{new Date(scope.row.payTime * 1000).toLocaleString()}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="chargeNum"
                    label="缴费数量"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="chargeCell"
                    label="缴费单位"
                    width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.chargeCell == 'month'"><el-tag>按月</el-tag></span>
                    <span v-else><el-tag type="success">按年</el-tag></span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="channelMoney"
                    label="通道单价"
                    width="100">
                <template slot-scope="scope">
                    {{(Number(scope.row.channelMoney) / 100).toFixed(2)}}
                </template>
            </el-table-column>
            <el-table-column
                    prop="totalMoney"
                    label="缴费金额"
                    width="160">
                <template slot-scope="scope">
                    {{(Number(scope.row.totalMoney) / 100).toFixed(2)}}
                </template>
            </el-table-column>

            <el-table-column
                    prop="invoiceFlag"
                    label="开票标识"
                    width="100">
                <template slot-scope="scope">
                    <span v-if="scope.row.invoiceFlag == 0"><el-tag type="info">未开票</el-tag></span>
                    <span v-else><el-tag type="success">已开票</el-tag></span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="remark"
                    label="备注信息">
            </el-table-column>

        </el-table>
    </div>
</template>

<script>
    export default {
        name: "Record",
        data() {
            return {
                tableData: []
            }
        },
        methods:{
            getTableInfo(){
                let query = {
                    "test":"test"
                };
                this.axios.post("/api/sct/chargeRecord/list",query).then(res=>{
                    // eslint-disable-next-line no-empty
                    if (res.status == 200){
                        let responseData = res.data;
                        if (responseData.code == 0){
                            console.log(responseData);
                            this.tableData = responseData.data;
                        }else {
                            this.$message.warning(res.msg);
                        }
                    }else {
                        this.$message.error("服务器内部错误，请联系售后人员！");
                    }
                });
            }
        },
        mounted(){
            this.getTableInfo();
        }
    }
</script>

<style scoped>

</style>